<template>
  <div>
    <Row>
      <i-col span="24" class="text-right">
        <i-button type="primary" class="m-r-5" size="small"  @click="showHistory=true">审批记录</i-button>
        <i-button type="primary" class="m-r-5" size="small"  v-if="isAuth('Statement_DownloadPDF')"  @click="showApprovalHistoryModal">下载审批记录</i-button>
        <i-button type="primary" class="m-r-5" size="small" @click="handleShowOrder">查看订单详情</i-button>
        <i-button type="primary" class="m-r-5" size="small"  @click="handleDownload">下载结算单</i-button>
        <i-button type="error" class="m-r-5" size="small"  @click="handleInvalid" v-if="allowInvalid">作废</i-button>
        <i-button type="error" class="m-r-5" size="small"  @click="handleChangeCode"  v-if="nullifiable">更改编号</i-button>
      </i-col>
    </Row>

    <statement-detail-component ref="statementDetail"  :versionId="otherParams"  :id="id" @on-inited="handleInited" />
    <invalid-component ref="invalidComponent" :id="id"  @on-success="handleInvalidSuccess"></invalid-component>
    <Modal v-model="showHistory" :width="800">
      <Tabs v-model="chkVersionId" size="small" class="text-white">
        <TabPane
          v-for="item in versionList"
          :key="item.versionId"
          :label="(item.versionId+'')===(otherParams+'')?'当前生效版本':('版本'+item.versionId)"
          :name="item.versionId+''"
        >
        </TabPane>
      </Tabs>

      <history :relateId="chkVersionId" :type="approvalType" v-if="showHistory"></history>
    </Modal>
<Modal v-model="showDownLoadApprovalHistoryModal">
      <h3 class="p-b-10" slot="header">下载确认</h3>
      <Row>
        <i-col span="24" class="p-t-10">
          <h4 class="p-b-5">审批记录范围</h4>
          <RadioGroup v-model="isAllVersion">
            <Radio label="1">
              <span>完整审批记录</span>
            </Radio>
            <Radio label="0">
              <span>最新审批记录</span>
            </Radio>
          </RadioGroup>
        </i-col>
      </Row>

      <div slot="footer">
        <Button type="text" @click="showDownLoadApprovalHistoryModal = false"
          >取消</Button
        >
        <Button type="primary" @click="handleDownloadPDF">确认</Button>
      </div>
    </Modal>
    <!-- 弹窗 订单详情 -->
    <OrderDetail ref="orderDetail"/>

  </div>
</template>

<script>
import History from '@/components/approval/History'
import statementDetailComponent from '@/components/statement/StatementDetailComponent'
import OrderDetail from '@/components/order/common/ModalOrderDetail'
import InvalidComponent from '@/components/contract/contractDetail/detail/InvalidComponent'
import { invalidStatement, changeStatementCode } from '@/api/scp/statement'
import { getVersionIdListByContractId } from '@/api/scp/contract'

import { downloadFileRequest } from '@/utils/download'

export default {
  components: {
    History,
    statementDetailComponent,
    OrderDetail,
    InvalidComponent
  },
  props: {
    baseId: {
      required: true
    },
    otherParams: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showInvalid: false,
      desc: '',
      id: 0,
      orderId: 0,
      showHistory: false,
      showDownLoadApprovalHistoryModal: false,
      isAllVersion: '1',
      allowInvalid: false,
      nullifiable: false,
      statement: {},
      approvalType: 7,
      versionList: [],
      chkVersionId: 0
    }
  },
  methods: {
    handleReasonChanged (reason) {
      this.desc = reason
    },
    handleViewChanged (show) {
      this.showInvalid = show
    },
    handleInvalid () {
      this.$refs.invalidComponent.initPage()
    },

    handleInvalidSuccess () {
      this.$refs.statementDetail.getDetail()
    },
    handleConfirmed () {
      invalidStatement({ statementId: this.id, invalidMark: this.desc }).then(
        res => {
          if (res && !res.errcode) {
            this.$Notice.success({ desc: '结算单作废成功', title: '操作成功' })
            this.showInvalid = false
            this.$refs.statementDetail.getDetail()
          }
        }
      )
    },
    handleChangeCode () {
      let newCode = this.statement.code
      this.$Modal.confirm({
        title: '更改结算单的编号',
        render: h => {
          return h('Input', {
            props: {
              value: newCode
            },
            on: {
              'on-change': event => {
                newCode = event.target.value
              }
            }

          })
        },
        onOk: () => {
          const that = this
          changeStatementCode({ statementId: this.id, statementCode: newCode }).then(res => {
            if (res && !res.errcode) {
              that.$Notice.success({ desc: '更改编号成功' })
              that.$refs.statementDetail.getDetail()
            }
          })
        }
      })
    },
    handleDownload () {
      let downloadFilename = '广告发布结算单('
      downloadFilename += this.statement.advertiserName
      downloadFilename += this.statement.code
      downloadFilename += ').doc'

      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-scp/v1/statement/downloadStatement', { statementId: this.id }, downloadFilename)
    },
    showApprovalHistoryModal () {
      this.showDownLoadApprovalHistoryModal = true
    },

    handleDownloadPDF () {
      // const filename = '广告发布合同(' + this.contract.code + ')' + '.pdf'
      let downloadFilename = '广告发布结算单('
      downloadFilename += this.statement.advertiserName
      downloadFilename += this.statement.code
      downloadFilename += ').pdf'
      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-scp/v1/contractexport/downloadpdf', { contractId: this.id, isAllVersion: this.isAllVersion === '1' }, downloadFilename)
    },
    handleShowOrder () {
      this.$refs.orderDetail.init(this.orderId)
    },
    handleInited (statement) {
      this.statement = statement
      getVersionIdListByContractId({ contractId: this.id }).then(res => {
        this.versionList = res
        this.chkVersionId = this.otherParams + ''
      })
      this.orderId = statement.orderIdList[0]
      this.nullifiable = (statement.status !== -1 && this.isAuth('Statement_ChangeCode'))
      this.allowInvalid = (statement.status !== -1 && this.isAuth('Statement_Invalid'))
    }
  },

  created () {
    this.id = this.baseId
  },
  watch: {
    baseId (val) {
      this.id = this.baseId
    },
    chkVersionId () {
      if (this.versionList.length) {
        const chkVersion = this.versionList.filter(x => x.versionId === parseInt(this.chkVersionId))[0]
        this.approvalType = chkVersion.processType
      }
    }
  }

}
</script>
